var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "campaign-result" },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.rewards.length
            ? _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c("div", { staticClass: "campaign-result-header" }, [
                        _c("h2", { staticClass: "gray--text" }, [
                          _vm._v("\n            Benefícios\n          "),
                        ]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "gray--text mt-1 mb-1" }, [
                          _vm._v("\n            Disponível para resgate: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.getCostValue(_vm.balance))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "gray--text" }, [
                          _vm._v(
                            "\n            Compre mais com " +
                              _vm._s(
                                _vm.partnerInitials
                                  ? `a ${_vm.partnerInitials}`
                                  : "o parceiro"
                              ) +
                              " para liberar mais benefícios.\n            "
                          ),
                          _c(
                            "a",
                            { attrs: { href: _vm.onLinkPdf, target: "blank" } },
                            [
                              _vm._v(
                                "\n              Regulamento e Produtos Participantes\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("RewardsCard", {
                        attrs: {
                          items: _vm.rewards,
                          "disabled-button":
                            _vm.disabledButton ||
                            _vm.selectedRewards.length === 0,
                          selectedRewards: _vm.selectedRewards,
                        },
                        on: {
                          "rescue-rewards": _vm.rescueRewards,
                          "select-reward": _vm.selectReward,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isNotManualResultMethod
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("AppBody", {
                attrs: {
                  "table-title": "Meta",
                  headers: _vm.triggersHeaders,
                  items: _vm.triggers,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("RewardsRescueModal", {
        ref: "rewardsRescueModal",
        attrs: {
          items: _vm.selectedRewards,
          balance: _vm.balance,
          rescueType: _vm.campaign.rebateDetails.rescueType,
        },
        on: { "finalizing-rewards-rescue": _vm.finalizingRewardsRescue },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }